import React, { Component } from "react";
import JobTrackIframeEmbed from "components/common/JobTrackIframeEmbed";
import TwoColumnLayout from "layouts/TwoColumn";
import StorageGateway from "lib/storage-gateway";
import queryString from "query-string";

class IframeRouteScreen extends Component {
  render() {
    const queryParams = queryString.parse(window.location.search);
    const routeId = queryParams?.route_id;

    const iframeSrc = `${
      process.env.REACT_APP_JOBTRAKS_BASE_URL
    }screen/157/360%20view?New%20Card=${encodeURIComponent(
      `{"route_id":${routeId}}`,
    )}&Ratio%20Component=${encodeURIComponent(
      `{"route_id":${routeId}}`,
    )}&Budget%20%5E%26%20Schedule%20Test=${encodeURIComponent(
      `{"route_id":${routeId},"id":${routeId}}`,
    )}&View%20Route=${encodeURIComponent(
      `{"pk":${routeId}}`,
    )}&Associated%20Supervisors=${encodeURIComponent(
      `{"id":${routeId}}`,
    )}&Versioning=${encodeURIComponent(`{"route_id":${routeId}}`)}&embed=true`;

    return (
      <TwoColumnLayout hideFooter={true}>
        <JobTrackIframeEmbed src={iframeSrc} />
      </TwoColumnLayout>
    );
  }
}

export default IframeRouteScreen;
